module.exports = __webpack_public_path__ + "img/qa-engineering.e42de024.svg";